import * as firebase from "firebase";
var config = {
  apiKey: "AIzaSyCvQEwP5Kp5iBb78AvdjwHe5wfG2ruOvbA",
  authDomain: "deknerd-556e6.firebaseapp.com",
  databaseURL: "https://deknerd-556e6.firebaseio.com",
  projectId: "deknerd-556e6",
  storageBucket: "deknerd-556e6.appspot.com",
  messagingSenderId: "434518633712",
  appId: "1:434518633712:web:d564d8f1be8efe1014a635"
};
firebase.initializeApp(config);
var database = firebase;
export default database